import React from "react";
import { bonuses } from "../data/bonuses";
import { CtaButton } from "./ui/CtaButton";
import { ImageSlot } from "./ui/ImageSlot";
import { Accent, SectionHeading } from "./ui/SectionHeading";
export function Bonuses() {
  return <section id="bonus" className="scroll-mt-16 bg-terracotta px-3 py-10 sm:px-6 sm:py-16" data-id="element-1" data-mp="aujy257rdx0u">
      <div className="mx-auto max-w-5xl rounded-[32px] bg-cream px-4 py-12 shadow-[0_20px_44px_-30px_rgba(86,18,54,0.6)] sm:px-8 sm:py-16" data-id="element-2" data-mp="fsv6cbienzgy">
        <SectionHeading title={<>
              5 bonus. <Accent italic data-id="element-4" data-mp="5xbeq1avjmy0">Inclusi gratis.</Accent>
            </>} subtitle="Tuoi in omaggio insieme al bundle di ricette." data-id="element-3" data-mp="5w0c44t60l8h" />

        <ul className="mt-10 space-y-6 sm:space-y-8" data-id="element-5" data-mp="3t06fmr4lw57w">
          {bonuses.map(b => <li key={b.number} className="grid overflow-hidden rounded-[28px] border border-line bg-cream md:grid-cols-2" data-id="element-6" data-mp="1mai4007n42xu">
              <ImageSlot src={b.image} alt={`Anteprima del bonus ${b.name}`} placeholderLabel={`Immagine del bonus n° ${b.number}`} className="aspect-[3/2] h-full w-full md:aspect-auto md:min-h-[340px]" data-id="element-7" data-mp="1r78s9atlm4uc" />
              <div className="p-5 sm:p-7" data-id="element-8" data-mp="3r68gtb7wra3u">
                <span className="inline-block rounded-full bg-[#B36C64] px-5 py-2 text-[13px] font-bold uppercase tracking-[0.1em] text-white" data-id="element-9" data-mp="3n5erqeiqbp9d">
                  Bonus n° {b.number} · Gratis
                </span>
                <h3 className="mt-4 font-serif text-[26px] font-semibold leading-[1.15] text-wine sm:text-[30px]" data-id="element-10" data-mp="2uh0ptnois8sj">
                  {b.name}
                </h3>
                <ul className="mt-4 border-t border-line" data-id="element-11" data-mp="38dw2rr7w6kdv">
                  {b.benefits.map(({
                icon: Icon,
                lead,
                text
              }) => <li key={lead} className="flex items-start gap-4 border-b border-line py-4 last:border-0" data-id="element-12" data-mp="npi3scdwrwsn">
                      <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-chip text-rose" data-id="element-13" data-mp="irpzeiw2ui7k">
                        <Icon className="h-[18px] w-[18px]" strokeWidth={1.5} aria-hidden="true" data-id="element-14" data-mp="3ci4u1afrrdqr" />
                      </span>
                      <p className="text-[15px] leading-relaxed text-ink sm:text-base" data-id="element-15" data-mp="3hk3zqqyzemqv">
                        <strong className="font-semibold text-wine" data-id="element-16" data-mp="3lke4k0b1f745">{lead}</strong> {text}
                      </p>
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 flex justify-center" data-id="element-17" data-mp="2xtqup9hka7ey">
          <CtaButton data-id="element-18" data-mp="2xujrbhmt3gjd">Ottieni il bundle e tutti e 5 i bonus</CtaButton>
        </div>
      </div>
    </section>;
}